var BREAKPOINT_XXSMALL = 0;
var BREAKPOINT_XSMALL = 401;
var BREAKPOINT_SMALL = 541;
var BREAKPOINT_MEDIUM = 721;
var BREAKPOINT_LARGE = 901;
var BREAKPOINT_XLARGE = 1025;
var BREAKPOINT_XXLARGE = 1281;
var FONT_WEIGHTS = {
    light: 300,
    regular: 400,
    medium: 500,
    semiBold: 600,
    bold: 700
};
var theme = {
    breakpoints: {
        xxsmall: BREAKPOINT_XXSMALL,
        xsmall: BREAKPOINT_XSMALL,
        small: BREAKPOINT_SMALL,
        medium: BREAKPOINT_MEDIUM,
        large: BREAKPOINT_LARGE,
        xlarge: BREAKPOINT_XLARGE,
        xxlarge: BREAKPOINT_XXLARGE
    },
    sidebarWidth: '240px',
    sidebarV2Width: '401px',
    topbarHeight: '64px',
    color: {
        backgroundGrey: '#fcfcfd',
        black: '#000',
        completedStepBackgroundGrey: '#727a85',
        disabledInputBackground: '#fafafa',
        disabledInputBorder: '#dddddd',
        facebook: '#3b5998',
        green: '#0ac57e',
        grey: '#8e949e',
        lightGreen: '#62daad',
        lightGrey: '#d9dbdf',
        lightRed: '#fa7268',
        linkedin: '#0077b5',
        orcid: '#9cc732',
        primaryBrand: '#59d3ce',
        primaryBrandHover: '#29c2b5',
        primaryBrandLight: '#ddfaf8',
        primaryLink: '#065de0',
        primaryLinkHover: '#0047b3',
        purple: '#855daf',
        red: '#ea6060',
        secondaryBrand: '#424d5d',
        sidebarGrey: '#f5f6f7',
        sidebarHover: '#f0f1f2',
        transparent: 'transparent',
        twitter: '#1da1f2',
        warning: 'rgba(252,252,98,0.25)',
        white: '#ffffff',
        yellow: '#ffc107'
    },
    borderRadius: {
        small: '0.1875rem',
        regular: '0.5rem',
        large: '3rem'
    },
    textSizes: {
        h1_new: {
            fontSize: ['4rem', '4rem'],
            lineHeight: ['4.75rem', '4.75rem'],
            font: 'Acta Display',
            fontWeight: FONT_WEIGHTS.regular
        },
        h2_new: {
            fontSize: ['2.8125rem', '2.8125rem'],
            lineHeight: ['3.625rem', '3.625rem'],
            font: 'Acta Display',
            fontWeight: FONT_WEIGHTS.regular
        },
        h3_new: {
            fontSize: ['1.8125rem', '2rem'],
            lineHeight: ['2.25rem', '2.75rem'],
            font: 'Open Sans',
            fontWeight: FONT_WEIGHTS.semiBold
        },
        h4_new: {
            fontSize: ['1.35rem', '1.4375rem'],
            lineHeight: ['1.6rem', '2rem'],
            font: 'Open Sans',
            fontWeight: FONT_WEIGHTS.regular
        },
        h5_new: {
            fontSize: ['1rem', '1.1875rem'],
            lineHeight: ['1.5rem', '2rem'],
            font: 'Open Sans',
            fontWeight: FONT_WEIGHTS.regular
        },
        body1_new: {
            fontSize: ['1rem', '1rem'],
            lineHeight: ['1.5rem', '1.5rem'],
            font: 'Open Sans',
            fontWeight: FONT_WEIGHTS.regular
        },
        body2_new: {
            fontSize: ['0.875rem', '0.875rem'],
            lineHeight: ['1.5rem', '1.5rem'],
            font: 'Open Sans',
            fontWeight: FONT_WEIGHTS.regular
        },
        body3: {
            fontSize: ['0.8125rem', '0.8125rem'],
            lineHeight: ['1.125rem', '1.125rem'],
            font: 'Open Sans',
            fontWeight: FONT_WEIGHTS.regular
        },
        caption_new: {
            fontSize: ['0.75rem', '0.75rem'],
            lineHeight: ['1rem', '1rem'],
            font: 'Open Sans',
            fontWeight: FONT_WEIGHTS.regular
        }
    },
    fontWeights: FONT_WEIGHTS,
    palettes: {
        primary: {
            background: 'primaryBrand',
            font: 'white',
            disabledFont: 'white',
            backgroundHover: 'primaryBrandHover',
            border: 'transparent',
            borderHover: 'transparent',
            disabledBackground: 'lightGrey'
        },
        secondary: {
            background: 'white',
            font: 'secondaryBrand',
            disabledFont: 'grey',
            backgroundHover: 'white',
            border: 'lightGrey',
            borderHover: 'secondaryBrand',
            disabledBackground: 'white'
        },
        red: {
            background: 'white',
            font: 'red',
            disabledFont: 'red',
            backgroundHover: 'white',
            border: 'red',
            borderHover: 'red',
            disabledBackground: 'lightGrey'
        },
        twitter: {
            background: 'twitter',
            font: 'white',
            disabledFont: 'white',
            backgroundHover: 'twitter',
            border: 'transparent',
            borderHover: 'transparent',
            disabledBackground: 'lightGrey'
        },
        facebook: {
            background: 'facebook',
            font: 'white',
            disabledFont: 'white',
            backgroundHover: 'facebook',
            border: 'transparent',
            borderHover: 'transparent',
            disabledBackground: 'lightGrey'
        },
        linkedin: {
            background: 'linkedin',
            font: 'white',
            disabledFont: 'white',
            backgroundHover: 'linkedin',
            border: 'transparent',
            borderHover: 'transparent',
            disabledBackground: 'lightGrey'
        },
        orcid: {
            background: 'orcid',
            font: 'white',
            disabledFont: 'white',
            backgroundHover: 'orcid',
            border: 'transparent',
            borderHover: 'transparent',
            disabledBackground: 'lightGrey'
        },
        danger: {
            background: 'red',
            font: 'white',
            disabledFont: 'white',
            backgroundHover: 'red',
            border: 'red',
            borderHover: 'red',
            disabledBackground: 'lightGrey'
        }
    },
    z: {
        toast: 4000,
        popperFlyout: 3001,
        cookieBanner: 2002,
        modal: 2001,
        flyout: 1040,
        topbar: 1003,
        footer: 1002,
        sidebar: 1001,
        sidebarOverlay: 1000,
        topbarOverlay: 900,
        contextNavPrev: 801,
        contextNavNext: 800,
        backToPageLink: 100,
        borderMenuListV2: 1005
    }
};
export default theme;
//# sourceMappingURL=index.js.map